
/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { SearchableItem, SearchableSelectionType } from './interface';

export class RoT implements SearchableItem {
  ID: string;
  INDUSTRY: string;
  NAICS: number;
  SIC: string;

  //SDE
  SDE_LOW: number;
  SDE_HI: number;
  SDE_TYPE: ValueType;
  SDE_INV: boolean;
  SDE_INV_PLUS: boolean;
  SDE_WARN: boolean;

  //EBITDA
  EBITDA_LOW: number;
  EBITDA_HI: number;
  EBITDA_TYPE: ValueType;
  EBITDA_INV: boolean;
  EBITDA_INV_PLUS: boolean;
  EBITDA_WARN: boolean;

  //Revenue
  REVENUE_LOW: number;
  REVENUE_HI: number;
  REVENUE_TYPE: ValueType;
  REVENUE_INV: boolean;
  REVENUE_INV_PLUS: boolean;
  REVENUE_WARN: boolean;

  // Helpers
  active = false;
  allowed = false;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parseArray(json: any[]): RoT[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new RoT(j));
        }
      }
    }

    return arr;
  }

  static parse(json: any): RoT {
    if (json) {
      const f = new RoT();
      f.ID = json.ID;
      f.INDUSTRY = json.INDUSTRY;
      f.NAICS = json.NAICS;
      f.SIC = json.SIC;

      f.SDE_LOW = json.SDE_LOW;
      f.SDE_HI = json.SDE_HI;
      f.SDE_TYPE = json.SDE_TYPE;
      f.SDE_INV = json.SDE_INV;
      f.SDE_INV_PLUS = json.SDE_INV_PLUS;

      f.EBITDA_LOW = json.EBITDA_LOW;
      f.EBITDA_HI = json.EBITDA_HI;
      f.EBITDA_TYPE = json.EBITDA_TYPE;
      f.EBITDA_INV = json.EBITDA_INV;
      f.EBITDA_INV_PLUS = json.EBITDA_INV_PLUS;

      f.REVENUE_LOW = json.REVENUE_LOW;
      f.REVENUE_HI = json.REVENUE_HI;
      f.REVENUE_TYPE = json.REVENUE_TYPE;
      f.REVENUE_INV = json.REVENUE_INV;
      f.REVENUE_INV_PLUS = json.REVENUE_INV_PLUS;
      return f;
    } else { return null; }
  }

  getName(): string {
    return this.INDUSTRY;
  }

  getFullDetails(): string {
    if(this.NAICS)
      return `${this.NAICS} - ${this.INDUSTRY}`;
    else return this.INDUSTRY;
  }

  getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
  }

  getValue(): any {
    return this;
  }
}

export enum ValueType {
  PERCENT = 'PERCENT',
  MULTIPLE = 'MULTIPLE'
}
